import { useQuery } from '@tanstack/react-query';
import { fetchMetadata } from 'api/metadata';
import { MetadataApiResponse } from 'types';
import { queryKeys } from 'utils';

export function useGetMetadata() {
  // react-router-dom can't be used here
  const isGa4ConfigPage = window.location.pathname.includes('/configure-ga4');
  return useQuery<MetadataApiResponse>({
    queryKey: queryKeys.metadata(),
    queryFn: fetchMetadata,
    enabled: !isGa4ConfigPage,
  });
}
